<div class="list-group mb-3">
  <div class="list-group-item edit-menu-item-active">
    <form [formGroup]="inputFieldForm" class="edit-menu-form">
      <!-- Type Select and Required Option -->
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label for="name">
              <span>Type</span>
              <scitis-required-field-indicator></scitis-required-field-indicator>
            </label>
          </div>
        </div>
        <div class="form-group">
          <ng-select (change)="onFormFieldTypeChange($event)"
            [clearable]="false"
            [ngModel]="inputField.formFieldType"
            [items]="formFieldTypes"
            [ngClass]="{'is-invalid': formControls.formFieldType.errors}"
            [placeholder]="'Select field type ...'|translate"
            [searchable]="false"
            formControlName="formFieldType"
            id="formFieldType">
          </ng-select>
          @if (formControls.formFieldType.errors) {
            <div class="invalid-feedback">
              @if (formControls.formFieldType.errors.required) {
                <span
                translate>Selection of type is required</span>
              }
            </div>
          }
        </div>
      </div>
      <!-- General Options -->
      @if (inputField.datatype) {
        <div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="name">
                  <span>Name</span>
                  <em [ngbTooltip]="'Sets the BigQuery column name. This field cannot be changed after saving.'|translate"
                    class="fa-solid fa-circle-question text-muted ml-1"
                  placement="top"></em>
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                </label>
                <input (input)="emitInputFieldName()"
                  [attr.disabled]="disableInputFieldNameInput? true: null"
                  [ngClass]="{'is-invalid': formControls.name.errors}" class="form-control"
                  formControlName="name" id="name"
                  type="text"/>
                  @if (formControls.name.errors) {
                    <div class="invalid-feedback">
                      @if (formControls.name.errors.required) {
                        <span
                        translate>Name field cannot be empty</span>
                      }
                      @if (formControls.name.errors.bigQueryValidName && !formControls.name.errors.required) {
                        <span
                        translate>Table column name can only contain letters, numbers and underscore and can only begin with a letter or underscore.</span>
                      }
                      @if (formControls.name.errors.columnNameNotUnique && !formControls.name.errors.required) {
                        <span
                        translate>Table column name already exists.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="label">
                    <span>Label</span>
                    <scitis-required-field-indicator></scitis-required-field-indicator>
                  </label>
                  <input (input)="emitInputFieldLabel()" [ngClass]="{'is-invalid': formControls.label.errors}"
                    class="form-control" formControlName="label"
                    id="label" type="text"/>
                    @if (formControls.label.errors) {
                      <div class="invalid-feedback">
                        @if (formControls.label.errors.required) {
                          <span
                          translate>Label field cannot be empty</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                @if (!(isBoolean || isTimestamp)) {
                  <div class="col">
                    <div class="form-group">
                      <label for="placeholder">
                        <span translate>Placeholder</span>
                      </label>
                      <input (input)="emitInputFieldPlaceholder()" class="form-control" formControlName="placeholder"
                        id="placeholder"
                        type="text"/>
                      </div>
                    </div>
                  }
                </div>
                <div class="row" style="margin-top: 10px; margin-bottom: 10px">
                  <div class="col-6">
                    @if (!(isBoolean || isTimestamp)) {
                      <div class="btn-group btn-group-toggle" name="radioBasic"
                        ngbRadioGroup>
                        <label [class.active]="inputField.dropdown" class="btn btn-outline-primary btn-sm"
                          ngbButtonLabel>
                          <input (click)="toggleDropdown()" ngbButton
                            type="radio">
                            <span translate>Dropdown</span>
                          </label>
                          <label [class.active]="inputField.list" class="btn btn-outline-primary btn-sm"
                            ngbButtonLabel>
                            <input (click)="toggleList()" ngbButton
                              type="radio">
                              <span translate>List</span>
                            </label>
                          </div>
                        }
                      </div>
                      <div class="col-6">
                        <div class="btn-group btn-group-toggle" name="radioBasic2"
                          ngbRadioGroup>
                          <label [class.active]="inputField.required" class="btn btn-outline-primary btn-sm"
                            ngbButtonLabel>
                            <input (click)="onMakeFieldRequiredChange()" ngbButton
                              type="radio">
                              <span translate>Required Field</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          @if (inputField.dropdown) {
                            <div class="form-group">
                              <label for="placeholder">
                                <span translate>Dropdown Options</span>
                              </label>
                              @if (isString) {
                                <div class="input-group">
                                  <input #dropdownItem
                                    [ngClass]="{'is-invalid': formControls.dropdownOption.errors || isInputFieldEmpty()}"
                                    class="form-control" formControlName="dropdownOption" type="text"/>
                                    <div class="input-group-append">
                                      <button (click)="onAddDropdownItem(dropdownItem)" class="btn btn-outline-primary"
                                        type="button">
                                        <span translate>Add</span>
                                      </button>
                                    </div>
                                    @if (formControls.dropdownOption.errors) {
                                      <div class="invalid-feedback">
                                        @if (formControls.dropdownOption.errors.required) {
                                          <span
                                          translate>Text input required</span>
                                        }
                                      </div>
                                    }
                                    @if (isInputFieldEmpty()) {
                                      <div class="invalid-feedback"
                                        translate>At least 1 option is required
                                      </div>
                                    }
                                  </div>
                                }
                                @if (isNumber) {
                                  <div class="input-group">
                                    <input #dropdownItem
                                      [ngClass]="{'is-invalid': formControls.dropdownOption.errors || isInputFieldEmpty()}"
                                      class="form-control"
                                      formControlName="dropdownOption" type="number"/>
                                      <div class="input-group-append">
                                        <button (click)="onAddDropdownItem(dropdownItem)" class="btn btn-outline-primary"
                                          type="button">
                                          <span translate>Add</span>
                                        </button>
                                      </div>
                                      @if (formControls.dropdownOption.errors) {
                                        <div class="invalid-feedback">
                                          @if (formControls.dropdownOption.errors.required) {
                                            <span
                                            translate>Number input required</span>
                                          }
                                        </div>
                                      }
                                      @if (isInputFieldEmpty()) {
                                        <div class="invalid-feedback"
                                          translate>At least 1 option is required
                                        </div>
                                      }
                                    </div>
                                  }
                                  <ul class="list-group">
                                    @for (value of inputField.options; track value; let i = $index) {
                                      <li class="list-group-item">
                                        <span [innerHTML]="value"></span>
                                        <button (click)="onDeleteDropdownItem(i)" class="btn btn-outline-danger btn-sm float-right"
                                          type="button">
                                          &times;
                                        </button>
                                      </li>
                                    }
                                  </ul>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </form>
                  </div>
                </div>
